import { BellSimpleIcon, CaretDownIcon } from '@phosphor-icons/react';
import { Dropdown, Layout } from 'antd';
import { useNavigate } from 'react-router-dom';

import adminLogo from '@/assets/images/admin-logo.webp';
import { UserAvatar } from '@/components/common/user-avatar';
import { routes } from '@/config/routes';
import { useLogout } from '@/features/auth';
import { useAuth } from '@/providers/auth-provider';

import { SidebarNav } from './sidebar-nav';
import styles from './sidebar.module.scss';
import { useSidebarStore } from './use-sidebar-store';

const { Sider } = Layout;

function formatRole(role: string): string {
  return role
    .split('_')
    .map((w) => (w ? w[0]!.toUpperCase() + w.slice(1) : w))
    .join(' ');
}

export function Sidebar() {
  const { collapsed } = useSidebarStore();
  const { user, clearSession } = useAuth();
  const navigate = useNavigate();
  const logout = useLogout();

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      trigger={null}
      width={215}
      collapsedWidth={64}
      className={styles.sider}
    >
      <div className={styles.brand}>
        <button
          type="button"
          className={styles.logoBtn}
          aria-label="Go to dashboard"
          onClick={() => navigate(routes.dashboard)}
        >
          <img className={styles.logo} src={adminLogo} alt="Greenway Admin" />
        </button>
        <button
          type="button"
          className={styles.bell}
          aria-label="Notifications"
          onClick={() => navigate(routes.notifications)}
        >
          <BellSimpleIcon size={20} weight="fill" className={styles.bellFill} />
          <BellSimpleIcon size={20} weight="regular" className={styles.bellLine} />
        </button>
      </div>

      <SidebarNav roles={user?.role ? [user.role] : undefined} />

      {user ? (
        <Dropdown
          trigger={['click']}
          menu={{
            items: [
              {
                key: 'logout',
                label: 'Log out',
                onClick: async () => {
                  await logout.mutateAsync();
                  clearSession();
                  navigate(routes.login);
                },
              },
            ],
          }}
        >
          <button type="button" className={styles.userCard}>
            <UserAvatar
              name={`${user.firstName} ${user.lastName}`}
              size="lg"
              label={`${user.firstName} ${user.lastName}`}
              subtitle={formatRole(user.role)}
            />
            <CaretDownIcon size={14} className={styles.userCaret} />
          </button>
        </Dropdown>
      ) : null}
    </Sider>
  );
}
